import React, { useState, useEffect } from "react";
import { 
  Box, TextField, Button, Typography, Select, MenuItem, FormControl, InputLabel, 
  Alert, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  IconButton, Chip, Dialog, DialogTitle, DialogContent, DialogActions, Divider 
} from "@mui/material";
import { collection, addDoc, serverTimestamp, query, orderBy, onSnapshot, deleteDoc, doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import SendIcon from '@mui/icons-material/Send';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

function BildirimYonetimi() {
  // --- Yeni Bildirim State'leri ---
  const [baslik, setBaslik] = useState("");
  const [mesaj, setMesaj] = useState("");
  const [hedefSube, setHedefSube] = useState("");
  const [status, setStatus] = useState({ type: "", msg: "" });
  
  // --- Veri ve Düzenleme State'leri ---
  const [gecmisBildirimler, setGecmisBildirimler] = useState([]);
  const [editingBildirim, setEditingBildirim] = useState(null); // Düzenlenen bildirim verisi
  const [openEditModal, setOpenEditModal] = useState(false); // Modal açık mı?

  const subeler = [
    { id: "hepsi", name: "TÜM ŞUBELER" },
    { id: "kavakli_sube", name: "Kavaklı Şubesi" },
    { id: "sefakoy_sube", name: "Sefaköy Şubesi" },
    { id: "sefakoy_merkez", name: "Sefaköy Merkez Şubesi" }
  ];

  useEffect(() => {
    const q = query(collection(db, "bildirimler"), orderBy("tarih", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setGecmisBildirimler(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, []);

  // --- YENİ BİLDİRİM GÖNDERME ---
  const handleGonder = async () => {
    if (!baslik || !mesaj || !hedefSube) {
      setStatus({ type: "error", msg: "Lütfen tüm alanları doldurun." });
      return;
    }

    try {
      await addDoc(collection(db, "bildirimler"), {
        baslik,
        mesaj,
        hedefSube,
        okunanSubeler: [], 
        tarih: serverTimestamp()
      });
      setStatus({ type: "success", msg: "Bildirim gönderildi!" });
      setBaslik("");
      setMesaj("");
      setHedefSube(""); 
    } catch (error) {
      setStatus({ type: "error", msg: "Hata: " + error.message });
    }
  };

  // --- BİLDİRİM SİLME ---
  const handleSil = async (e, id) => {
    e.stopPropagation(); // Satıra tıklamayı engelle (Modal açılmasın)
    if(window.confirm("Bu bildirimi silmek istediğinize emin misiniz?")) {
      await deleteDoc(doc(db, "bildirimler", id));
    }
  };

  // --- BİLDİRİM DÜZENLEME İŞLEMLERİ ---
  
  // Tablo satırına tıklanınca
  const handleRowClick = (bildirim) => {
    setEditingBildirim(bildirim);
    setOpenEditModal(true);
  };

  // Modal içindeki inputlar değişince
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditingBildirim(prev => ({ ...prev, [name]: value }));
  };

  // Düzenlemeyi Kaydet
  const handleEditSave = async () => {
    if (!editingBildirim.baslik || !editingBildirim.mesaj || !editingBildirim.hedefSube) {
      alert("Alanlar boş bırakılamaz.");
      return;
    }

    try {
      const docRef = doc(db, "bildirimler", editingBildirim.id);
      await updateDoc(docRef, {
        baslik: editingBildirim.baslik,
        mesaj: editingBildirim.mesaj,
        hedefSube: editingBildirim.hedefSube
      });
      setOpenEditModal(false);
      setEditingBildirim(null);
      setStatus({ type: "success", msg: "Bildirim güncellendi." });
    } catch (error) {
      console.error("Güncelleme hatası:", error);
      alert("Güncelleme sırasında hata oluştu.");
    }
  };

  const getSubeName = (subeId) => {
    const sube = subeler.find(s => s.id === subeId);
    return sube ? sube.name : subeId;
  };

  return (
    <Box className="by-page" sx={{ p: 1, background: "linear-gradient(165deg, #f5f2eb 0%, #ece6da 45%, #e2dacd 100%)", height: "calc(100% - 18px)", minHeight: 0, overflow: "hidden" }}>
      <Typography className="by-title" variant="h4" fontWeight={700} color="#0f172a" mb={2.5} textAlign="center" sx={{ letterSpacing: "0.01em" }}>
        BİLDİRİM YÖNETİMİ
      </Typography>

      <Box className="by-layout" sx={{ display: 'flex', gap: 1.5, flexDirection: { xs: 'column', md: 'row' }, height: { xs: 'auto', md: 'calc(100% - 84px)' }, minHeight: 0, overflow: "hidden" }}>
        {/* SOL: GÖNDERME FORMU */}
        <Paper className="by-form-paper" elevation={0} sx={{ p: 1.8, flex: 1, borderRadius: 3, border: "1px solid rgba(212,175,98,0.24)", boxShadow: "0 10px 24px rgba(15,23,42,0.12)", minHeight: 0, overflow: "hidden" }}>
          <Typography variant="h6" gutterBottom fontWeight={700} color="#0f172a">Yeni Bildirim Gönder</Typography>
          {status.msg && <Alert severity={status.type} sx={{ mb: 2 }}>{status.msg}</Alert>}

          <FormControl className="by-form-field" fullWidth margin="normal">
            <InputLabel>Hedef Şube</InputLabel>
            <Select className="by-form-select" value={hedefSube} label="Hedef Şube" onChange={(e) => setHedefSube(e.target.value)}>
              {subeler.map((s) => <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField className="by-form-field" fullWidth label="Başlık" margin="normal" value={baslik} onChange={(e) => setBaslik(e.target.value)} />
          <TextField className="by-form-field" fullWidth label="Mesaj İçeriği" margin="normal" multiline rows={5} value={mesaj} onChange={(e) => setMesaj(e.target.value)} />
          <Button className="by-send-btn" fullWidth variant="contained" size="large" startIcon={<SendIcon />} onClick={handleGonder} sx={{ mt: 2, fontWeight: 700, background: "linear-gradient(180deg, #1f2937 0%, #0f172a 100%)", border: "1px solid rgba(212,175,98,0.4)", "&:hover": { background: "linear-gradient(180deg, #273549 0%, #152235 100%)" } }}>
            GÖNDER
          </Button>
        </Paper>

        {/* SAĞ: GEÇMİŞ BİLDİRİMLER */}
        <Paper className="by-history-paper" elevation={0} sx={{ p: 1.8, flex: 1.5, borderRadius: 3, border: "1px solid rgba(212,175,98,0.24)", boxShadow: "0 10px 24px rgba(15,23,42,0.12)", display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden" }}>
          <Typography variant="h6" gutterBottom fontWeight={700} color="#0f172a">Geçmiş Bildirimler</Typography>
          <Typography className="by-history-hint" variant="caption" display="block" gutterBottom color="text.secondary">
            Düzenlemek veya detay görmek için satıra tıklayın.
          </Typography>
          <TableContainer className="by-table-wrap" sx={{ flex: 1, minHeight: 0, maxHeight: { xs: 360, md: "100%" }, overflowY: "auto", border: "1px solid rgba(212,175,98,0.18)", borderRadius: 2 }}>
            <Table className="by-table" size="small" stickyHeader>
              <TableHead>
                <TableRow sx={{ background: "linear-gradient(180deg, #111827 0%, #0b1220 100%)" }}>
                  <TableCell sx={{ fontWeight: 800, color: "#f8fafc", bgcolor: "#0f172a" }}>Tarih</TableCell>
                  <TableCell sx={{ fontWeight: 800, color: "#f8fafc", bgcolor: "#0f172a" }}>Başlık</TableCell>
                  <TableCell sx={{ fontWeight: 800, color: "#f8fafc", bgcolor: "#0f172a" }}>Hedef</TableCell>
                  <TableCell sx={{ fontWeight: 800, color: "#f8fafc", bgcolor: "#0f172a" }}>Okuyanlar</TableCell>
                  <TableCell sx={{ fontWeight: 800, color: "#f8fafc", bgcolor: "#0f172a" }}>Sil</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {gecmisBildirimler.map((b) => (
                  <TableRow 
                    key={b.id}
                    className="by-data-row"
                    hover 
                    onClick={() => handleRowClick(b)} 
                    sx={{ cursor: 'pointer', transition: 'background 0.2s', '&:nth-of-type(odd)': { bgcolor: 'rgba(248,250,252,0.92)' }, '&:hover': { bgcolor: 'rgba(212,175,98,0.12)' } }}
                  >
                    <TableCell className="by-cell-date" data-label="Tarih" sx={{ fontSize: '0.85rem' }}>
                      {b.tarih?.toDate().toLocaleDateString('tr-TR')}
                      <br/>
                      <span style={{ color: 'gray', fontSize: '0.75rem' }}>
                        {b.tarih?.toDate().toLocaleTimeString('tr-TR', {hour: '2-digit', minute:'2-digit'})}
                      </span>
                    </TableCell>
                    <TableCell className="by-cell-title" data-label="Başlık" sx={{ fontWeight: '500' }}>{b.baslik}</TableCell>
                    <TableCell className="by-cell-target" data-label="Hedef">
                      <Chip 
                        label={subeler.find(s => s.id === b.hedefSube)?.name || b.hedefSube} 
                        size="small" 
                        variant="outlined" 
                        color="primary"
                      />
                    </TableCell>
                    <TableCell className="by-cell-readers" data-label="Okuyanlar">
                      {b.okunanSubeler && b.okunanSubeler.length > 0 ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          {b.okunanSubeler.map((subeId, index) => (
                            <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontSize: '0.85rem', color: '#15803d' }}>
                                • {getSubeName(subeId)}
                            </Box>
                          ))}
                        </Box>
                      ) : (
                        <span style={{ color: '#9ca3af', fontStyle: 'italic', fontSize: '0.85rem' }}>
                          Henüz okunmadı
                        </span>
                      )}
                    </TableCell>
                    <TableCell className="by-cell-delete" data-label="Sil">
                      <IconButton color="error" size="small" onClick={(e) => handleSil(e, b.id)}><DeleteIcon /></IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>

      {/* --- DÜZENLEME MODALI (DIALOG) --- */}
      <Dialog
        className="by-edit-dialog"
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ className: "by-edit-dialog-paper" }}
      >
        <DialogTitle sx={{ background: "linear-gradient(180deg, #111827 0%, #0b1220 100%)", color: "#f8fafc" }}>
          Bildirim Detayı / Düzenle
        </DialogTitle>
        <DialogContent dividers>
          {editingBildirim && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <FormControl fullWidth>
                <InputLabel>Hedef Şube</InputLabel>
                <Select 
                  name="hedefSube"
                  value={editingBildirim.hedefSube} 
                  label="Hedef Şube" 
                  onChange={handleEditChange}
                >
                  {subeler.map((s) => <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)}
                </Select>
              </FormControl>
              
              <TextField 
                fullWidth 
                label="Başlık" 
                name="baslik"
                value={editingBildirim.baslik} 
                onChange={handleEditChange} 
              />
              
              <TextField 
                fullWidth 
                label="Mesaj İçeriği" 
                name="mesaj"
                multiline 
                rows={6} 
                value={editingBildirim.mesaj} 
                onChange={handleEditChange} 
              />

              <Divider sx={{ my: 1 }}>
                <Chip label="Okunma Durumu" size="small" />
              </Divider>
              
              <Box sx={{ bgcolor: '#f8fafc', p: 2, borderRadius: 2, border: "1px solid rgba(212,175,98,0.2)" }}>
                {editingBildirim.okunanSubeler && editingBildirim.okunanSubeler.length > 0 ? (
                  <Typography variant="body2" color="success.main" fontWeight="bold">
                    Okuyan Şubeler: {editingBildirim.okunanSubeler.map(id => getSubeName(id)).join(", ")}
                  </Typography>
                ) : (
                  <Typography variant="body2" color="text.secondary" fontStyle="italic">
                    Henüz hiçbir şube tarafından okunmadı.
                  </Typography>
                )}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions className="by-edit-dialog-actions" sx={{ p: 2, background: "linear-gradient(180deg, #fcfbf8 0%, #f5f1eb 100%)" }}>
          <Button onClick={() => setOpenEditModal(false)} color="inherit">İptal</Button>
          <Button onClick={handleEditSave} variant="contained" startIcon={<EditIcon />} sx={{ fontWeight: 700, background: "linear-gradient(180deg, #1f2937 0%, #0f172a 100%)", border: "1px solid rgba(212,175,98,0.35)", "&:hover": { background: "linear-gradient(180deg, #273549 0%, #152235 100%)" } }}>
            Değişiklikleri Kaydet
          </Button>
        </DialogActions>
      </Dialog>
      <style>{`
        /* --- MOBİL: Bildirim Yönetimi (masaüstü sx stillerine dokunulmaz) --- */
        @media (max-width: 1649px), (max-width: 1400px) and (any-pointer: coarse) {
          .by-page {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            min-height: 0 !important;
            height: auto !important;
            overflow-x: hidden !important;
            overflow-y: visible !important;
            padding: 6px 8px 80px !important;
            box-sizing: border-box !important;
          }

          .by-title {
            font-size: 1.35rem !important;
            line-height: 1.25 !important;
            margin-bottom: 14px !important;
            padding: 0 4px !important;
          }

          .by-layout {
            flex-direction: column !important;
            height: auto !important;
            min-height: 0 !important;
            overflow: visible !important;
            gap: 12px !important;
            width: 100% !important;
            max-width: 100% !important;
          }

          .by-form-paper,
          .by-history-paper {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            flex: none !important;
            padding: 14px 10px !important;
            overflow: visible !important;
            box-sizing: border-box !important;
          }

          .by-form-paper .MuiInputBase-input,
          .by-form-paper .MuiSelect-select {
            font-size: 16px !important;
          }

          .by-send-btn {
            min-height: 44px !important;
          }

          .by-history-hint {
            font-size: 0.75rem !important;
            line-height: 1.35 !important;
          }

          .by-table-wrap {
            flex: none !important;
            max-height: none !important;
            overflow: visible !important;
            border: none !important;
            background: transparent !important;
            width: 100% !important;
            max-width: 100% !important;
          }

          .by-table {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
          }

          .by-table thead {
            display: none !important;
          }

          .by-table tbody {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
          }

          .by-table tbody tr.by-data-row {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            margin-bottom: 10px !important;
            border: 1px solid rgba(212, 175, 98, 0.22) !important;
            border-radius: 12px !important;
            overflow: hidden !important;
            background: rgba(255, 255, 255, 0.95) !important;
            box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06) !important;
            box-sizing: border-box !important;
          }

          .by-table tbody tr.by-data-row:nth-of-type(odd),
          .by-table tbody tr.by-data-row:nth-of-type(even) {
            background-color: rgba(255, 255, 255, 0.95) !important;
          }

          .by-table tbody tr.by-data-row td {
            display: grid !important;
            grid-template-columns: minmax(0, 34%) minmax(0, 1fr) !important;
            gap: 8px !important;
            align-items: center !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            padding: 10px 12px !important;
            border: none !important;
            border-bottom: 1px solid rgba(15, 23, 42, 0.06) !important;
            text-align: right !important;
            font-size: 13px !important;
            word-break: break-word !important;
            overflow-wrap: anywhere !important;
            box-sizing: border-box !important;
          }

          .by-table tbody tr.by-data-row td:last-child {
            border-bottom: none !important;
          }

          .by-table tbody tr.by-data-row td::before {
            content: attr(data-label) !important;
            font-weight: 700 !important;
            color: #64748b !important;
            font-size: 12px !important;
            text-align: left !important;
            min-width: 0 !important;
          }

          .by-table .by-cell-delete {
            justify-items: end !important;
          }

          .by-table .by-cell-delete::before {
            align-self: center !important;
          }

          .by-table .MuiTableCell-root {
            min-width: 0 !important;
            max-width: 100% !important;
          }

          .by-edit-dialog-paper {
            width: calc(100vw - 24px) !important;
            max-width: calc(100vw - 24px) !important;
            margin: 12px !important;
            max-height: calc(100svh - 24px) !important;
          }

          .by-edit-dialog .MuiInputBase-input,
          .by-edit-dialog .MuiSelect-select {
            font-size: 16px !important;
          }

          .by-edit-dialog-actions {
            flex-wrap: wrap !important;
            gap: 8px !important;
            justify-content: stretch !important;
          }

          .by-edit-dialog-actions .MuiButton-root {
            flex: 1 1 auto !important;
            min-height: 44px !important;
          }
        }
      `}</style>
    </Box>
  );
}

export default BildirimYonetimi;